import React from "react";
import Header from "./header";
import Main from "./main";
import FooterHabitacional from "../../Habitacional/core/Footer";
import { useNuvidio } from "../../../hooks";
import Wrapper from "./RunOffPageLayout.Style";

const RunOffPageLayout = (props) => {
  const { children } = props;

  useNuvidio();

  return (
    <Wrapper {...props}>
      <Header />
      <Main>{children}</Main>
      <FooterHabitacional />
    </Wrapper>
  );
};

RunOffPageLayout.propTypes = {};

export default RunOffPageLayout;
